import { IconCheck32 } from '@warp-ds/icons/react';

export const CheckMark = () => <IconCheck32 className="w-32 flex-none" aria-hidden style={{ color: '#FF84B6' }} />;
